import React, { useEffect, useState } from "react";
import { Content, Row, Col, Box, Button, Inputs } from "adminlte-2-react";

import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";

import SelectInput from "../utils/SelectInput";
import Loader from "../utils/Loader";

import ReferenciaObligatorios from "../utils/etiquetaObligatorio/ReferenciaObligatorios";
import Etiqueta from "../utils/etiquetaObligatorio/Etiqueta";

const { Text } = Inputs;

const styles = {
  containerStyle: { maxWidth: 600, marginLeft: "auto", marginRight: "auto" }
};

export default function EditarNotifTemplate({ history, match }) {
  const dispatch = useDispatch();
  const notifTemplateId = match.params.id;
  const [titulo, setTitulo] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [tipo, setTipo] = useState("");
  const [periodoCantidad, setPeriodoCantidad] = useState("");
  const [periodoUnidad, setPeriodoUnidad] = useState("");
  const [accion, setAccion] = useState("");
  const [mensajeAccion, setMensajeAccion] = useState("");
  const [estado, setEstado] = useState("");

  const modelNotifTemplates = useSelector((state) => state.notifTemplates);

  const modelEdicionNotifTemplate = useSelector((state) => {
    return state.edicionNotifTemplate;
  });

  useEffect(() => {
  
    dispatch(controller.getNotifTemplatesThunk({_id: notifTemplateId, page: 1, limit: 1}));
  }, []);

  useEffect(() => {


    const data = modelNotifTemplates?.data?.data?.data?.items?.[0];
    const error = modelNotifTemplates?.error;
    const errorMessage = modelNotifTemplates?.error?.response?.data?.mensaje;

    if (errorMessage) {
      alert(errorMessage);
    }

    if (error) {
   
      alert(
        "Ocurrió un error al intentar obtener datos. Por favor, intente nuevamente."
      );
    }

    if (data) {
     
      
      setTitulo(data?.titulo || "");
      setMensaje(data?.mensaje || "");
      setTipo(data?.tipo || "");
      setPeriodoCantidad(data?.periodoCantidad || 0);
      setPeriodoUnidad(data?.periodoUnidad || "");
      setAccion(data?.accion || "");
      setMensajeAccion(data?.mensajeAccion || "");      
      setEstado(data?.estado || "");

      dispatch(controller.getNotifTemplatesDuck.actions.clear());
    }
  }, [modelNotifTemplates, dispatch]);

  useEffect(() => {
    const data = modelEdicionNotifTemplate?.data?.data;
    const error = modelEdicionNotifTemplate?.error;
    const errorCode = error?.response?.status;
    const errorMessage = modelEdicionNotifTemplate?.error?.response?.data?.mensaje;

    if (errorMessage) {
      alert(errorMessage);
    }
    if (error) {
    
      dispatch(controller.editarNotifTemplateDuck.actions.clear());
    }
    if (data) {
      alert("Edición exitosa");
      dispatch(controller.editarNotifTemplateDuck.actions.clear());
      // history.push("/quizList");
    }
  }, [modelEdicionNotifTemplate, dispatch, history]);

  const editar = () => {
  
    // const token = localStorage.getItem("token");
    let data = {
      _id: notifTemplateId,
      titulo,
      mensaje,
      tipo,
      periodoCantidad,
      periodoUnidad,
      accion,
      mensajeAccion: accion === "whatsapp" ? mensajeAccion : null,
      estado,
    };
    dispatch(controller.editarNotifTemplateThunk(data));
  };

  const validateAndSetPeriodoCantidad = (value) => {
    if (value < 0) {
      setPeriodoCantidad(0);
      return;
    }
    setPeriodoCantidad(value);
  };

  const mostrarMensajeAccion = accion === "whatsapp" ? true : false;

  const values = {
    nombre: "Mario Salazar",
    clase: "Corte de pelo",
    local: "Carol Beauty",
    fecha: "21-07-2022 14:30",
  }

  const replacePlaceHolders = (mensaje) => {
    let msj = mensaje;
    Object.keys(values).forEach((key) => {
      msj = msj.replace(`{{${key}}}`, values[key]);
    });
    return msj;
  };

  return (
    <Content
      title="Notificación"
      subTitle="Edición"
      browserTitle="Notificación - Edición"
      show={false}
    >
      <Row>
        <Col>
          <Box
            title="Detalles"
            style={styles.containerStyle}
          >

            <ReferenciaObligatorios/>

            <Text
              value={titulo}
              labelPosition="above"
              size="sm"
              label="Título"
              onChange={(evt) => setTitulo(evt.target.value)}
            />

            <Text
              value={mensaje}
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Mensaje" obligatorio={true} />}
              onChange={(evt) => setMensaje(evt.target.value)}
              help="Podés utilizar los siguientes placeholders: {{nombre}}, {{clase}}, {{local}} y {{fecha}}"
            />
            <div style={{marginBottom:20}}>
            <h4>Previsualizacion</h4>
            <text style={{paddingBottom:100}}>{replacePlaceHolders(mensaje)}</text>
            </div>
  

            <SelectInput
              value={accion}
              setValue={setAccion}
              label="Acción"
              options={[
                { value: "whatsapp", label: "Enviar mensaje vía Whatsapp" },
                { value: "redireccion", label: "Redirección" },
              ]}
            />
            {mostrarMensajeAccion && (
              <Text
                value={mensajeAccion}
                labelPosition="above"
                size="sm"
                label="Mensaje whatsapp"
                onChange={(evt) => setMensajeAccion(evt.target.value)}
              />
            )}
            <SelectInput
              value={tipo}
              setValue={setTipo}
              label="Tipo"
              options={[
                { value: "recordatorio", label: "Recordatorio" },
                { value: "pago", label: "Pago" },
              ]}
            />
            <SelectInput
              value={estado}
              setValue={setEstado}
              label="Estado"
              options={[
                { value: "ACTIVO", label: "Activo" },
                { value: "INACTIVO", label: "Inactivo" },
              ]}
            />
          </Box>
          <Box
            title="Enviar con anticipación de"
            style={styles.containerStyle}
          >
            <Row>
              <Col xs="12" sm="3">
                <Text
                  value={periodoCantidad}
                  inputType="number"
                  labelPosition="none"
                  size="md"
                  // label="Cantidad"
                  onChange={(evt) => validateAndSetPeriodoCantidad(evt.target.value)}
                />
              </Col>
              <Col xs="12" sm="7">
                <SelectInput
                  value={periodoUnidad}
                  setValue={setPeriodoUnidad}
                  // label="Unidad"
                  labelPosition="none"
                  options={[
                    { value: "hours", label: "Horas" },
                    { value: "days", label: "Días" },
                  ]}
                />
              </Col>
            </Row>
          </Box>
          <Box
            style={styles.containerStyle}
          >

            <Button
              text="Cancelar"
              disabled={false}
              onClick={() => {
                history.push(`/`);
              }}
            />

            <Button
              type="primary"
              text={
                <Loader loaderColor="#ffffff" isLoading={modelNotifTemplates.loading}>
                  Guardar
                </Loader>
              }
              disabled={modelNotifTemplates.loading}
              pullRight={true}
              onClick={editar}
            />
          </Box>
        </Col>
      </Row>
    </Content>
  );
}
